<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
  <ng-container dialog-title>Add New Prize Group</ng-container>

  <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
    <form [formGroup]="form.formGroup" class="row add-exchange-form">
      <div [ngClass]="{'item-with-error': form.controls[0].errors?.length > 0}" class="col-12">
        <app-amount-input [onlyIntegers]="true" [control]="form.controls[0]"
          [formControlName]="form.controls[0].name"></app-amount-input>
      </div>
      <div [ngClass]="{'item-with-error': form.controls[1].errors?.length > 0}" class="col-12">
        <app-amount-input [onlyIntegers]="true" [control]="form.controls[1]"
          [formControlName]="form.controls[1].name"></app-amount-input>
      </div>
      <div [ngClass]="{'item-with-error': form.controls[2].errors?.length > 0}" class="col-12">
        <app-amount-input [control]="form.controls[2]"
          [formControlName]="form.controls[2].name"></app-amount-input>
      </div>
      <div [ngClass]="{'item-with-error': form.controls[3].errors?.length > 0}" class="col-12">
        <app-amount-input [control]="form.controls[3]"
          [formControlName]="form.controls[3].name"></app-amount-input>
      </div>
    </form>
  </ng-container>
</app-dialog>
